import {Box, Button} from '@mui/material';
import React from 'react';
import {useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';

export default function HomeHeaderBar() {
  const navigate = useNavigate();
  const token = useSelector(state => state.login.token);
  const handleCreateNewTool = () => {
    if (!token) {
      return navigate('/login');
    }
    navigate(`/NewPOCTool`);
  };

  return (
    <Box style={styles.container}>
      <h2>POC Content Management</h2>
      <Button variant="contained" onClick={handleCreateNewTool}>
        Create New Tool
      </Button>
    </Box>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
};
